<template>
  <div class="st-title-container">
    <h3 class="st-subtitle">
      {{ name }}
    </h3>
    <b-button
        v-if="alert"
        v-b-popover.hover.top="popoverOptions"
        variant="link"
        class="p-0"
    >
      <i class="sr sr-information"></i>
    </b-button>
  </div>
</template>

<script>
export default {
  name: "CommonSubtitle",
  props: {
    name: {
      type: [String],
      required: true
    },
    alert: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      popoverOptions: {
        content: "Улс төрд нөлөө бүхий этгээд гэж Монгол Улсын Ерөнхийлөгч, Улсын Их Хурлын гишүүн, Монгол Улсын Ерөнхий сайд, Засгийн газрын гишүүн, Үндсэн хуулийн цэцийн гишүүн, Улсын дээд шүүхийн Ерөнхий шүүгч, Улсын дээд шүүхийн шүүгч, Улсын ерөнхий прокурор, Улсын Их Хуралд ажлаа шууд хариуцан тайлагнадаг байгууллагын дарга, аймаг, нийслэлийн Засаг дарга, аймаг, нийслэлийн иргэдийн Төлөөлөгчдийн Хурлын Тэргүүлэгчдийн дарга, яамны Төрийн нарийн бичгийн дарга, Засгийн газрын агентлагийн дарга, төрийн өмчит компанийн дарга, захирал, гадаад орны төрийн тэргүүн, засгийн газрын тэргүүн, улс төрийн болон засгийн газар, шүүх, цэрэг армийн өндөр албан тушаалтан, төрийн өмчийн аж ахуйн нэгжийн удирдах албан тушаалтан, улс төрийн намын удирдлагад багтдаг хүн, олон улсын байгууллагын удирдах зөвлөлийн гишүүн, дарга, захирал, орлогч захирлын албан тушаал эрхэлж байсан болон эрхэлж байгаа хүнийг ойлгоно.",
        triggers: 'hover focus',
        placement: 'top',
        customClass: 'custom-popover',
      },
    }
  }
}

</script>

<style scoped lang="scss">
.st-title-container {
  padding: 10px 20px;
  margin-bottom: 20px;
  background: linear-gradient(to right, rgba(var(--rgb-primary-color), 0.1), rgba(var(--rgb-primary-color), 0));
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  i {
    margin-left: 10px;
    color: var(--text-primary-color-new);
  }
}

.st-subtitle {
  color: var(--text-primary-color-new);
  padding: 0 !important;
  margin: 0 !important;
  font-size: 14px;
  font-weight: 700;
}

.custom-popover {
  background: var(--white-or-dark-color);
  color: var(--text-primary-color-new);
  font-size: 12px;
  max-width: 600px;
  border: 1px solid #ddd;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.custom-popover .arrow::after {
  border-top-color: white;
}
</style>
